import { render, staticRenderFns } from "./pm-price.vue?vue&type=template&id=24fea1e6&"
import script from "./pm-price.vue?vue&type=script&lang=js&"
export * from "./pm-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports